import React from "react";
import homeBanner from "../../images/homeBanner.jpg";
import moment from "moment";

const WelcomeBanner = ({ userData }) => {
  return (
    <div
      className="relative p-8 text-white overflow-hidden h-[280px] flex justify-center items-center"
      style={{
        backgroundImage: `url(${homeBanner})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="text-center">
        <h1 className="xl:text-5xl text-3xl font-bold mb-2">
        Hej {userData && userData.length > 0 ? userData[0].user_name : ""}
        </h1>
        <p className="text-xl opacity-90">
          {moment().format("dddd Do MMMM, YYYY")}
          <br />
          {moment().format("hh:mm A")}
        </p>
      </div>
    </div>
  );
};

export default WelcomeBanner;
